document.addEventListener( 'DOMContentLoaded', function () {
	let activeSeason = document.querySelector( '.season-option.active' )?.dataset.season || 'all';
	const urlParams = new URLSearchParams( window.location.search );

	const urlSeason = urlParams.get( 'season' );
	const urlCategory = urlParams.get( 'category' );
	const urlClub = urlParams.get( 'club' ) || 'all';

	if ( urlSeason ) {
		activeSeason = urlSeason;

		document.querySelectorAll( '.season-option' ).forEach( el => {
			el.classList.toggle( 'active', el.dataset.season === urlSeason );
		} );
	}

	if ( urlCategory ) {
		document.querySelectorAll( '.category-tabs .tab-item' ).forEach( el => {
			el.classList.toggle( 'active', el.dataset.category === urlCategory );
		} );
	}

	let activeClub = urlClub || 'all';
	document.querySelectorAll( '.club-option' ).forEach( el => {
		el.classList.toggle( 'active', el.dataset.clubId === activeClub );
	} );

	const activeClubOption = document.querySelector( '.club-option.active' );
	const clubBtn = document.querySelector( '.filter-btn[data-filter="club"]' );

	if ( clubBtn && activeClubOption ) {
		const label = activeClub === 'all' ? 'All Clubs' : activeClubOption.textContent;

		clubBtn.childNodes[ 0 ].textContent = label + ' ';
	}

	function loadArchivePosts( reset = true ) {
		const activeCategory =
			document.querySelector( '.category-tabs .tab-item.active' )?.dataset.category || '';

		const formData = new FormData();
		formData.append( 'action', 'load_archive_posts' );
		formData.append( 'nonce', archiveAjax.nonce );
		formData.append( 'category', activeCategory );
		formData.append( 'season', activeSeason );
		formData.append( 'club', activeClub );
		formData.append( 'offset', 0 );
		formData.append( 'limit', 9 );

		let postsGrid = document.querySelector( '.posts-grid' );

		if ( ! postsGrid ) {
			const container = document.querySelector( '.category-posts' );
			container.innerHTML = '<div class="posts-grid"></div>';
			postsGrid = container.querySelector( '.posts-grid' );
		}

		postsGrid.style.opacity = '0.4';

		if ( reset ) {
			let btnWrapper = document.querySelector( '.load-more-wrapper' );
			if ( btnWrapper ) btnWrapper.innerHTML = '';

			document.querySelectorAll( '.load-more-btn' ).forEach( btn => btn.remove() );
		}

		fetch( archiveAjax.ajax_url, {
			method: 'POST',
			body: formData,
		} )
			.then( res => res.json() )
			.then( response => {
				let btnWrapper = document.querySelector( '.load-more-wrapper' );

				if ( ! btnWrapper ) {
					btnWrapper = document.createElement( 'div' );
					btnWrapper.className = 'load-more-wrapper';
					document.querySelector( '.category-posts' ).appendChild( btnWrapper );
				}
				if ( response.data.total === 0 ) {
					postsGrid.innerHTML = '<p class="no-posts">No articles found.</p>';
					if ( btnWrapper ) btnWrapper.innerHTML = '';
					return;
				}

				postsGrid.innerHTML = response.data.content;

				postsGrid.style.opacity = '1';

				if ( btnWrapper ) {
					btnWrapper.innerHTML = response.data.button || '';
				}
			} );
	}
	document.addEventListener( 'click', function ( e ) {
		const tab = e.target.closest( '.category-tabs .tab-item' );
		if ( ! tab ) return;

		e.preventDefault();

		document
			.querySelectorAll( '.category-tabs .tab-item' )
			.forEach( el => el.classList.remove( 'active' ) );

		tab.classList.add( 'active' );

		loadArchivePosts( true );

		const category = tab.dataset.category;
		const params = new URLSearchParams( window.location.search );

		if ( category ) {
			params.set( 'category', category );
		} else {
			params.delete( 'category' );
		}

		if ( activeSeason && activeSeason !== 'all' ) {
			params.set( 'season', activeSeason );
		}

		const newUrl = params.toString().length
			? `${ window.location.pathname }?${ params }`
			: window.location.pathname;

		history.pushState( {}, '', newUrl );
	} );

	document.addEventListener( 'click', function ( e ) {
		const btn = e.target.closest( '.filter-btn' );
		const option = e.target.closest( '.club-option, .season-option' );

		if ( btn ) {
			const parent = btn.closest( '.filter-btn-dropdown' );
			document.querySelectorAll( '.filter-btn-dropdown' ).forEach( el => {
				if ( el !== parent ) el.classList.remove( 'active' );
			} );
			parent.classList.toggle( 'active' );
			return;
		}

		if ( option ) {
			const dropdown = option.closest( '.filter-btn-dropdown' );
			dropdown.classList.remove( 'active' );

			if ( option.classList.contains( 'club-option' ) ) {
				activeClub = option.dataset.clubId;

				document
					.querySelectorAll( '.club-option' )
					.forEach( el => el.classList.remove( 'active' ) );
				option.classList.add( 'active' );

				const label = activeClub === 'all' ? 'All Clubs' : option.textContent;
				document.querySelector(
					'.filter-btn[data-filter="club"]'
				).childNodes[ 0 ].textContent = label + ' ';

				const params = new URLSearchParams( window.location.search );
				activeClub === 'all' ? params.delete( 'club' ) : params.set( 'club', activeClub );

				history.pushState(
					{},
					'',
					`${ window.location.pathname }${ params.toString().length ? '?' + params : '' }`
				);
			}

			if ( option.classList.contains( 'season-option' ) ) {
				activeSeason = option.dataset.season;
				document
					.querySelectorAll( '.season-option' )
					.forEach( el => el.classList.remove( 'active' ) );
				option.classList.add( 'active' );

				const label = activeSeason === 'all' ? 'All Seasons' : activeSeason.toUpperCase();
				document.querySelector( '.filter-btn.season' ).childNodes[ 0 ].textContent =
					label + ' ';

				const params = new URLSearchParams( window.location.search );
				activeSeason === 'all'
					? params.delete( 'season' )
					: params.set( 'season', activeSeason );
				history.pushState(
					{},
					'',
					`${ window.location.pathname }${ params.toString().length ? '?' + params : '' }`
				);
			}

			loadArchivePosts( true );
			return;
		}

		document
			.querySelectorAll( '.filter-btn-dropdown' )
			.forEach( el => el.classList.remove( 'active' ) );
	} );

	document.addEventListener( 'click', function ( e ) {
		const btn = e.target.closest( '.load-more-btn' );
		if ( ! btn ) return;

		e.preventDefault();

		const loaded = parseInt( btn.dataset.loaded, 10 );
		const total = parseInt( btn.dataset.total, 10 );

		btn.disabled = true;
		btn.textContent = 'Loading...';

		const activeCategory =
			document.querySelector( '.category-tabs .tab-item.active' )?.dataset.category || '';

		const formData = new FormData();
		formData.append( 'action', 'load_archive_posts' );
		formData.append( 'nonce', archiveAjax.nonce );
		formData.append( 'offset', loaded );
		formData.append( 'limit', 8 );
		formData.append( 'category', activeCategory );
		formData.append( 'season', activeSeason );
		formData.append( 'club', activeClub );

		fetch( archiveAjax.ajax_url, {
			method: 'POST',
			body: formData,
		} )
			.then( res => res.json() )
			.then( response => {
				if ( ! response.success || ! response.data.content ) {
					btn.style.display = 'none';
					return;
				}

				const temp = document.createElement( 'div' );
				temp.innerHTML = response.data.content;

				document
					.querySelector( '.posts-grid' )
					.insertAdjacentHTML( 'beforeend', temp.innerHTML );

				const newLoaded = loaded + response.data.count;
				btn.dataset.loaded = newLoaded;

				if ( newLoaded >= total ) {
					btn.style.display = 'none';
				} else {
					btn.disabled = false;
					btn.textContent = 'Load More';
				}
			} );
	} );

	loadArchivePosts();
} );
